import {ColumnsType} from "antd/lib/table";
import {DiscountCodeDto, DiscountType} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {CrudTable, nameof} from "digimuth-components/dist";
import {ReactNode} from "react";
import {Tag} from "antd";
import moment from "moment";
import {discountTypeTranslation} from "../../helpers/DiscountTypeHelper";
import {TableProps} from "antd/lib/table";

interface DiscountCodesListProps extends CrudTableWrapperProps<DiscountCodeDto> {
    customActions?: () => ReactNode;
    tableProps?: TableProps<DiscountCodeDto>;
}

export default function DiscountCodesList(props: DiscountCodesListProps) {
    const columns: ColumnsType<DiscountCodeDto> = [
        {
            key: nameof<DiscountCodeDto>("code"),
            dataIndex: nameof<DiscountCodeDto>("code"),
            title: "Kod",
            render: (code: string) => <strong>{code}</strong>
        }, {
            key: nameof<DiscountCodeDto>("expirationDate"),
            dataIndex: nameof<DiscountCodeDto>("expirationDate"),
            title: "Data ważności",
            render: (date: string) => date ? <Tag color={+new Date(date) >= +new Date() ? "green" : "red"}>
                {moment(date).format("DD-MM-YYYY HH:mm:ss")}
            </Tag> : null
        }, {
            key: nameof<DiscountCodeDto>("discountType"),
            dataIndex: nameof<DiscountCodeDto>("discountType"),
            title: "Typ obniżki",
            render: (discountType: DiscountType) => <Tag>
                {discountTypeTranslation(discountType)?.translation}
            </Tag>
        }, {
            key: nameof<DiscountCodeDto>("discountValue"),
            dataIndex: nameof<DiscountCodeDto>("discountValue"),
            title: "Wartość obniżki"
        }, {
            key: nameof<DiscountCodeDto>("minimumOrderAmount"),
            dataIndex: nameof<DiscountCodeDto>("minimumOrderAmount"),
            title: "Minimalna kwota zamówienia"
        }, {
            key: nameof<DiscountCodeDto>("usageLimit"),
            dataIndex: nameof<DiscountCodeDto>("usageLimit"),
            title: "Limit użyć",
            render: (usageLimit?: number | null) => usageLimit ?? "Bez limitu"
        }
    ];

    return <>
        <CrudTable
            data={props.data}
            onAddClicked={props.onAddClicked}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            isLoading={props.isLoading}
            columns={columns}
            customActions={props.customActions}
            tableProps={props.tableProps}
            addButtonTitle={"+ Dodaj nowy kod rabatowy"}
            editButtonTitle={"Edytuj"}
            deleteButtonTitle={"Usuń"}
            deleteConfirmMessage={"Czy na pewno chcesz usunąć ten wpis?"}
            cancelButtonTitle={"Anuluj"}
        />
    </>
}
